import React from 'react';
import { getName } from '@home/utils/common';
import RenderImage from '@/pages/aigc/pages/Agent/ChatPage/components/TabComponent/RenderImage';
import GameIconRenderer from '@/pages/aigc/pages/Agent/ChatPage/components/TabComponent/GameIconRenderer';
import { getFilterOptionIcon, isGameTypeFilter } from '@/pages/aigc/pages/Agent/ChatPage/components/DownloadSettingsModal/utils';
import { IFilterOption } from '@/pages/aigc/pages/Agent/ChatPage/components/DownloadSettingsModal/_type';
import { GAME_TYPE_ICON_MAP } from '../../../../config/constant';

interface IFilterIconProps {
  dataKey: string;
  option: IFilterOption;
  isActive: boolean;
}

/**
 * 筛选器选项图标组件
 */
const FilterIcon: React.FC<IFilterIconProps> = ({ dataKey, option, isActive }) => {
  const finalIconSrc = getFilterOptionIcon(
    dataKey,
    option.value,
    isActive,
    option.icon,
    // 和产品核对后，只展示icon不展示icon_active
    // option.icon_active
  );

  if (!finalIconSrc) {
    return null;
  }

  // 游戏类型使用特殊渲染器
  if (isGameTypeFilter(dataKey)) {
    const defaultIcon = GAME_TYPE_ICON_MAP?.[option.value];
    return (
      // 和产品核对后，只展示icon不展示icon_active
      <GameIconRenderer
        icon={getName(isActive, '', option.icon)}
        defaultIcon={defaultIcon}
      />
    );
  }

  // 其他类型使用普通图片渲染
  return <RenderImage src={finalIconSrc} className="dba-download-settings-tag-icon" />;
};

export default FilterIcon;

